import { motion } from "framer-motion";
import { WHY_INDEXES } from "../data";
import { useI18n } from "../i18n";

export const WhyUs = () => {
  const { t } = useI18n();
  return (
    <section id="pourquoi" data-testid="why-us-section" className="relative py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("why.tag")}</span>
          <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-none">
            {t("why.title")} <br /> {t("why.titleBrand")}
          </h2>
        </div>

        <div className="border-t border-white/10">
          {WHY_INDEXES.map((idx, i) => (
            <motion.div
              key={idx}
              data-testid={`why-item-${idx}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-b border-white/10 items-start hover:bg-white/[0.02] transition-colors duration-500 px-2"
            >
              <div className="md:col-span-2 font-display font-900 text-5xl md:text-6xl text-cyan neon-text-glow leading-none">{idx}</div>
              <h3 className="md:col-span-4 font-display font-600 uppercase tracking-tight text-2xl md:text-3xl group-hover:translate-x-2 transition-transform duration-500">
                {t(`why.items.${idx}.title`)}
              </h3>
              <p className="md:col-span-6 text-neutral-400 font-light text-base md:text-lg leading-relaxed">
                {t(`why.items.${idx}.desc`)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
